export default __webpack_public_path__ + "static/media/p9logo312o-150x150.d2b48a67.png";